import * as types from './supportRetrieveUsernameActionTypes';

import { supportRetrieveUsernameEndpoint } from 'src/shared/app/base/settings/endpointSettings';

import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';

export function retrieveEmail(
  firstName: string,
  lastName: string,
  extraData: any,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(retrieveEmailRequest());

    return post(supportRetrieveUsernameEndpoint(eventId), {
      first_name: firstName,
      last_name: lastName,
      extra_data: extraData,
    })
      .then(parseResponse)
      .then((json) => {
        const { masked_details: details } = json;
        const { username } = details;
        const { membership_id: membershipId } = json;

        dispatch(supportRetrieveEmailSuccess(username, membershipId));
        return json;
      })
      .catch((exception) => {
        dispatch(retrieveEmailFailure(exception));

        throw exception;
      });
  };
}

export function retrieveEmailRequest() {
  return {
    type: types.SUPPORT_RETRIEVE_EMAIL_REQUEST,
  };
}

export function supportRetrieveEmailSuccess(
  username: string,
  membership_id = Number,
) {
  return {
    type: types.SUPPORT_RETRIEVE_EMAIL_SUCCESS,
    username,
    membership_id,
  };
}

export function retrieveEmailFailure() {
  return {
    type: types.SUPPORT_RETRIEVE_EMAIL_FAILURE,
  };
}

export function resetRetrievedUsername() {
  return {
    type: types.RESET_RETRIEVED_USERNAME,
  };
}
